import {ConcreteUsageForm} from '../../../fields/usage/types'

export const buildUsageForm = (): ConcreteUsageForm => {
  return {
    concreteUsage: undefined
  }
}
